import Alert from "react-bootstrap/esm/Alert";

function ApproxResultWarning({ approxResults }) {
  return (
    <div>
      <Alert className="bkgrnd-rg-green mt-3">
        <p className="text-center my-1">
          We don't know the fill for this exact tire, but{" "}
          {approxResults.length > 1 ? "" : "a"} tire
          {approxResults.length > 1 ? "s" : ""} with a different type of
          construction {approxResults.length > 1 ? "are" : "is"} displayed
          below. They should be able to be used to estimate the correct fill
          amount.
        </p>
      </Alert>
    </div>
  );
}

export default ApproxResultWarning;
